import { ShieldCheck } from "lucide-react";

export const DemoFirstNote = ({ className = "", testId = "demo-first-note" }) => (
  <p
    data-testid={testId}
    className={`inline-flex items-start gap-2.5 rounded-xl border border-volt/25 bg-volt/[0.06] px-4 py-3 text-left text-sm text-slate-100 ${className}`}
  >
    <ShieldCheck size={17} className="mt-0.5 shrink-0 text-volt" />
    <span>
      <span className="font-bold text-volt">See your demo first.</span> You only pay if you like
      it — nothing upfront.
    </span>
  </p>
);
